import { DisconnectOutlined, FolderOpenOutlined } from "@/icons"
import { CommentsForm } from "@/pages/IntegrationsPage/components/molecules/CommentsForm"
import {
  ConfigItem,
  DescriptionLabelConfigItem,
  FooterConfigItem
} from "@/pages/IntegrationsPage/components/molecules/ConfigItem"
import { useIntegration } from "@/pages/IntegrationsPage/hooks/useIntegration"

import type { GitLabConfigurationItemProps } from "."

export const GitLabConfigurationItem = (
  props: GitLabConfigurationItemProps
) => {
  const [_, { isPending, onRemove, onReset, isDirty, t, ...rest }] =
    useIntegration(props)
  const { keyPrefix, values } = props
  const { projectsCount, id } = values

  return (
    <ConfigItem
      values={values}
      Description={
        <DescriptionLabelConfigItem
          Icon={FolderOpenOutlined}
          tKey={`${keyPrefix}project_connected`}
          count={Number(projectsCount)}
        />
      }
    >
      <CommentsForm
        label={t(`${keyPrefix}enableComments`)}
        {...values}
        {...rest}
      />
      <FooterConfigItem
        formId={id}
        isDirty={isDirty}
        isPending={isPending}
        permissions={{ action: "*", resource: "*" }}
        removeTKey="general.disconnect"
        RemoveIcon={DisconnectOutlined}
        onRemove={() => onRemove(values)}
        onReset={onReset}
      />
    </ConfigItem>
  )
}
